import React, { cloneElement } from 'react';
import DefaultEdit from '../Edit';
import InfoDialog from '@au/core/lib/components/objects/InfoDialog';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import { BUTTON_TYPE_PRIMARY } from '@au/core/lib/components/elements/AuButton';
import { history as browserHistory } from '../../../history';
import { clearMountedFlag, fetchAllowedEnvironments } from '../../../utils/telemetryUtils';

import styles from '../../../css/components/sync_configs_create.module.scss';

const ENVIRONMENT_OPTION_FIELDS = new Set(['allowedEnvs', 'sourceEnv']);

export default class SyncConfigsCreate extends DefaultEdit {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      allowedEnvs: [],
      showSuccessDialog: false,
      syncId: null,
    };

    this.handleOnSave = this.handleOnSave.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    fetchAllowedEnvironments(this);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    clearMountedFlag(this);
  }

  getFormFields() {
    const options = this.state.allowedEnvs || [];

    // Inject the fetched environment options into the fields that need them,
    // leaving all other fields untouched.
    return super
      .getFormFields()
      .map((field) => (ENVIRONMENT_OPTION_FIELDS.has(field.props.field) ? cloneElement(field, { options }) : field));
  }

  handleOnSave(entity) {
    return this.props.endpoint
      .create({
        ...entity,
        ruleType: 'CONVERSION',
      })
      .then((resp) => {
        this.setState({ showSuccessDialog: true, syncId: resp.data.syncId });
      });
  }

  renderDialogs() {
    const dialogs = super.renderDialogs();
    dialogs.push(this.renderSuccessDialog());
    return dialogs;
  }

  handleDialogClosed() {
    this.setState({ showSuccessDialog: false });

    const { syncId } = this.state;
    const path = syncId ? this.baseUrl + `/${syncId}/view` : this.parentUrl;
    browserHistory.push(path);
  }

  renderSuccessDialog() {
    if (!this.state.showSuccessDialog) return false;
    return (
      <InfoDialog
        key='SuccessCreate'
        titleId='au.entity.success'
        className={styles.success_dialog}
        bodyClassName={styles.success_dialog_body}
        closeClassName={styles.success_dialog_close_button}
        buttonType={BUTTON_TYPE_PRIMARY}
        showClose={false}
        onClose={this.handleDialogClosed.bind(this)}
      >
        <AutoIntl displayId='au.telemetry.sync.create.success' tag='div' />
      </InfoDialog>
    );
  }
}
